import { LegalLayout } from '../components/LegalLayout';

export const PrivacyPolicy = () => {
    return (
        <LegalLayout title="Privacy Policy" lastUpdated="January 24, 2026">
            <p className="intro-text">
                At Nostavia Health ("we," "our," or "us"), your privacy is paramount. This Privacy Policy details how we collect, use, process, and safeguard your sensitive health and personal information when you use the Nostavia Health platform, mobile application, and related services (collectively, the "Services").
            </p>

            <section>
                <h2>1. Information We Collect</h2>
                <p>To provide our AI-driven health intelligence and longevity services, we collect various types of data:</p>
                <ul>
                    <li><strong>Personal Identity Information:</strong> Name, email address, phone number, date of birth, biological sex, and delivery address for lab services.</li>
                    <li><strong>Health & Biomarker Data:</strong> Results from blood panels (via our partners like Redcliffe Labs), self-reported health history, "Deep Scan" inputs, symptoms, and lifestyle metrics (diet, sleep, activity).</li>
                    <li><strong>Device & Usage Data:</strong> IP address, device type, operating system, and interaction logs with our AI features to improve user experience.</li>
                    <li><strong>Payment Information:</strong> We collect payment details via secure third-party processors (e.g., Razorpay, Stripe). We do not store full credit card numbers on our servers.</li>
                </ul>
            </section>

            <section>
                <h2>2. How We Use Your Information</h2>
                <p>We leverage your data to power our Health Intelligence System:</p>
                <ul>
                    <li><strong>Service Delivery:</strong> To coordinate home sample collection, process lab orders, and manage your membership.</li>
                    <li><strong>AI & Biological Age Analysis:</strong> To calculate your biological age, disease risks, and generate personalized "Deep Scan" reports using our proprietary algorithms.</li>
                    <li><strong>Service Improvement:</strong> We may use de-identified, aggregated data to refine our AI models and improve the accuracy of our health insights.</li>
                    <li><strong>Communication:</strong> To send you critical health alerts, report notifications, and membership updates.</li>
                </ul>
            </section>

            <section>
                <h2>3. Sharing of Information</h2>
                <p>
                    We do <strong>not</strong> sell your personal health data. We share data only as necessary to provide our Services:
                </p>
                <ul>
                    <li><strong>Lab Partners:</strong> We share necessary details (Name, Age, Gender, Address) with our diagnostic partners (e.g., Redcliffe Labs) solely to facilitate sample collection and report generation.</li>
                    <li><strong>Legal & Safety:</strong> We may disclose information if required by law, court order, or to protect the safety of our users.</li>
                    <li><strong>Business Transfers:</strong> In the event of a merger or acquisition, user data may be transferred as a business asset, subject to this policy.</li>
                </ul>
            </section>

            <section>
                <h2>4. International Data Transfers</h2>
                <p>
                    Nostavia Health operates globally. Your information may be transferred to, stored, and processed in countries other than your own, including India and the United States. By using our Services, you consent to this transfer, ensuring we maintain strict security standards across borders.
                </p>
            </section>

            <section>
                <h2>5. Data Security</h2>
                <p>
                    We employ enterprise-grade security measures, including encryption in transit (TLS) and at rest, customized access controls, and regular security audits. While we strive to protect your data, no method of transmission over the Internet is 100% secure.
                </p>
            </section>

            <section>
                <h2>6. Your Rights</h2>
                <p>
                    Depending on your jurisdiction, you may have the right to access, correct, or delete your personal data. You can manage most of your data directly within the app settings. For permanent account deletion requests, please contact support.
                </p>
            </section>

            <section>
                <h2>7. Children's Privacy</h2>
                <p>
                    Our Services are intended for adults (18+). We do not knowingly collect data from minors. If we discover we have collected information from a child, we will delete it immediately.
                </p>
            </section>

            <section>
                <h2>8. Contact Us</h2>
                <p>
                    For privacy-related inquiries, please contact our Data Protection Officer at contact@nostaviahealth.com.
                </p>
            </section>
        </LegalLayout>
    );
};
